package com.essntl.features.service.ui.components.unsplash

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.runtime.*
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.DpSize
import androidx.compose.ui.unit.dp
import com.essntl.core.unsplash.ui.UnsplashImage
import com.essntl.core.unsplash.ui.UnsplashPopup
import com.essntl.features.file.domain.model.FileModel
import com.essntl.features.file.ui.essntlgallery.EssntlGallery
import com.essntl.features.file.ui.essntlgallery.EssntlGalleryState
import com.essntl.uikit.components.file.FileViewer
import com.essntl.features.service.ui.addeditservice.AddEditServiceEvent
import com.essntl.features.service.ui.addeditservice.AddEditServiceState
import com.essntl.uikit.components.button.secondary.EsMediumSecondaryButton
import com.essntl.uikit.components.button.tinted.EsMediumTintedButton
import com.essntl.uikit.components.input.label.EsInputLabel
import com.essntl.uikit.components.scroll.EsHorizontalScrollbar
import com.essntl.uikit.components.utils.spacing

@Composable
fun ServiceUnsplash(
    state: AddEditServiceState,
    onEvent: (AddEditServiceEvent) -> Unit,
    enabled: Boolean,
) {

    var openUnsplashDialog by rememberSaveable { mutableStateOf(false) }
    var openEssntlGalleryDialog by rememberSaveable { mutableStateOf(false) }

    var fileUrl by rememberSaveable { mutableStateOf("") }
    var isFileViewerOpened by rememberSaveable { mutableStateOf(false) }

    EsInputLabel(
        label = "Photos",
    )

    if (state.imageState.getAllFile.data.orEmpty().isNotEmpty()) {
        Spacer(modifier = Modifier.height(.5.spacing))

        val listState = rememberLazyListState()

        LazyRow(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(2.spacing),
            state = listState,
        ) {
            itemsIndexed(
                state.imageState.getAllFile.data.orEmpty(),
                key = { index, imageModel -> "${imageModel.url}${index}" },
            ) { index, imageModel ->
                UnsplashImage(
                    url = imageModel.url,
                    imageSize = DpSize(264.dp, 160.dp),
                    enabled = enabled,
                    selected = index == state.thumbnailIndex,
                    onDelete = {
                        onEvent(AddEditServiceEvent.DeleteImage(index))
                    },
                    onSelect = {
                        onEvent(
                            AddEditServiceEvent.ToggleImageThumbnail(index),
                        )
                    },
                    onClick = {
                        isFileViewerOpened = true
                        fileUrl = imageModel.url
                    },
                )
            }
        }

        Spacer(modifier = Modifier.height(.5.spacing))

        EsHorizontalScrollbar(
            lazyListState = listState,
            modifier = Modifier.fillMaxWidth(),
        )
    }

    Spacer(modifier = Modifier.height(.5.spacing))

    Row {
        EsMediumTintedButton(
            text = "Get from Unsplash",
            onClick = {
                openUnsplashDialog = true
            },
            enabled = enabled,
            modifier = Modifier.weight(1f),
        )

        Spacer(modifier = Modifier.width(1.spacing))

        EsMediumSecondaryButton(
            text = "Odia Gallery",
            onClick = { openEssntlGalleryDialog = true },
            enabled = enabled,
            modifier = Modifier.weight(1f),
        )
    }

    EssntlGallery(
        entity = EssntlGalleryState.Entity.SERVICES,
        isOpen = openEssntlGalleryDialog,
        onDismissRequest = {
            openEssntlGalleryDialog = false
        },
        multipleSelect = true,
        onAddImages = { images ->
            val imagesToAdd = images.filter {
                !state.service.value.images
                    .orEmpty()
                    .contains(it.id)
            }
            if (imagesToAdd.isEmpty()) return@EssntlGallery
            onEvent(AddEditServiceEvent.AddImages(imagesToAdd))
        },
    )

    UnsplashPopup(
        isOpen = openUnsplashDialog,
        onDismissRequest = { openUnsplashDialog = false },
        multipleSelect = true,
        onAddImages = { urls, keyword ->
            onEvent(
                AddEditServiceEvent.AddImages(
                    urls.map {
                        FileModel.empty.copy(
                            url = it,
                            keywords = listOf(keyword),
                        )
                    },
                ),
            )
        },
    )

    FileViewer(
        fileUrl = fileUrl,
        isDialogOpened = isFileViewerOpened,
        onDismissRequest = {
            isFileViewerOpened = false
            fileUrl = ""
        },
    )
}